<template>
  <div :class="['leaf', extraClass]">
    <div v-for="(img, i) in leafImages" :key="i">
      <img :src="img" height="55" width="55" alt="" />
    </div>
  </div>
</template>

<script setup>
import el1 from '../media/home/background_elements/el1.png';
import el2 from '../media/home/background_elements/el2.png';
import el3 from '../media/home/background_elements/el3.png';
import el4 from '../media/home/background_elements/el4.png';
import el5 from '../media/home/background_elements/el5.png';
import el6 from '../media/home/background_elements/el6.png';
import el7 from '../media/home/background_elements/el7.png';

defineProps({
  extraClass: { type: String, default: '' },
});

const leafImages = [el1, el2, el3, el4, el5, el6, el7];
</script>
